import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-orange-50 to-white" data-id="element-2">
      <div className="max-w-6xl mx-auto" data-id="element-3">
        {/* Header */}
        <div className="text-center mb-6 md:mb-16" data-id="element-4">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-5 py-2 rounded-full font-bold text-sm md:text-lg mb-4 md:mb-6" data-id="element-5">
            <Gift className="w-5 h-5" data-id="element-6" />
            BONOS EXCLUSIVOS
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-gray-900 mb-3" data-id="element-7">
            Además, recibís{' '}
            <span className="text-orange-600" data-id="element-8">2 bonos gratis</span>
          </h2>
          <p className="text-base md:text-xl text-gray-600" data-id="element-9">
            Material extra para que tengas todo cubierto
          </p>
        </div>

        {/* Bonuses */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-8 max-w-4xl mx-auto" data-id="element-10">
          {/* Bonus 1 */}
          <div className="bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-lg md:shadow-xl border-2 border-orange-200" data-id="element-11">
            <div className="bg-gradient-to-br from-orange-500 to-red-500 py-1.5 md:py-4 text-white text-center font-bold text-xs md:text-lg" data-id="element-12">
              BONO #1
            </div>
            {/* Mobile: horizontal layout | Desktop: vertical layout */}
            <div className="p-3 md:p-6" data-id="element-13">
              <div className="flex gap-3 md:block" data-id="element-14">
                <img src="https://cdn.magicpatterns.com/uploads/rjKzqatpgXUEz66yQLQRSD/TDLO_BONO_1.png" alt="Banco de Actividades Rápidas" className="w-24 h-24 object-contain flex-shrink-0 md:w-full md:h-auto md:mb-6 rounded-lg md:mx-auto" data-id="element-15" />
                <div className="flex-1 min-w-0" data-id="element-16">
                  <h3 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2" data-id="element-17">
                    Banco de Actividades Rápidas Salva-Clases
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 mb-1 md:mb-3 line-clamp-2 md:line-clamp-none" data-id="element-18">
                    +30 actividades listas para usar en clases cortas,
                    suplencias o días complicados.
                  </p>
                  <ul className="hidden md:block space-y-1 text-sm text-gray-700 mb-3" data-id="element-19">
                    <li className="flex items-start gap-2" data-id="element-20">
                      <span className="text-orange-500 font-bold" data-id="element-21">•</span>
                      <span data-id="element-22">Actividades de 10 minutos</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-23">
                      <span className="text-orange-500 font-bold" data-id="element-24">•</span>
                      <span data-id="element-25">Dinámicas para curso inquieto</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-26">
                      <span className="text-orange-500 font-bold" data-id="element-27">•</span>
                      <span data-id="element-28">Disparadores para debate</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gradient-to-r from-green-500 to-green-600 text-white text-center py-1 md:py-2 px-3 rounded-lg font-bold text-xs md:text-sm mt-2 md:mt-0" data-id="element-29">
                HOY GRATIS CON TU COMPRA
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-lg md:shadow-xl border-2 border-orange-200" data-id="element-30">
            <div className="bg-gradient-to-br from-orange-500 to-red-500 py-1.5 md:py-4 text-white text-center font-bold text-xs md:text-lg" data-id="element-31">
              BONO #2
            </div>
            {/* Mobile: horizontal layout | Desktop: vertical layout */}
            <div className="p-3 md:p-6" data-id="element-32">
              <div className="flex gap-3 md:block" data-id="element-33">
                <img src="https://cdn.magicpatterns.com/uploads/qQQYzP4fTndqtyL7cMAq3e/TDLO_BONO_2.png" alt="Evaluaciones y Recuperatorios" className="w-24 h-24 object-contain flex-shrink-0 md:w-full md:h-auto md:mb-6 rounded-lg md:mx-auto" data-id="element-34" />
                <div className="flex-1 min-w-0" data-id="element-35">
                  <h3 className="text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-2" data-id="element-36">
                    Evaluaciones y Recuperatorios Listos
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 mb-1 md:mb-3 line-clamp-2 md:line-clamp-none" data-id="element-37">
                    Evaluaciones completas con rúbricas claras. Correcciones
                    rápidas y objetivas.
                  </p>
                  <ul className="hidden md:block space-y-1 text-sm text-gray-700 mb-3" data-id="element-38">
                    <li className="flex items-start gap-2" data-id="element-39">
                      <span className="text-orange-500 font-bold" data-id="element-40">•</span>
                      <span data-id="element-41">Evaluaciones + recuperatorios listos</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-42">
                      <span className="text-orange-500 font-bold" data-id="element-43">•</span>
                      <span data-id="element-44">Versión A y B por módulo</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-45">
                      <span className="text-orange-500 font-bold" data-id="element-46">•</span>
                      <span data-id="element-47">Claves de corrección</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gradient-to-r from-green-500 to-green-600 text-white text-center py-1 md:py-2 px-3 rounded-lg font-bold text-xs md:text-sm mt-2 md:mt-0" data-id="element-48">
                HOY GRATIS CON TU COMPRA
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}